import React from 'react';
import './Header.css';


const SubscriptionHeader = ({ title, subtitle }) => {
  return (
    <header className="header">
      <h1 className="text-center">{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </header>
  );
};

export default SubscriptionHeader;